module.exports = __webpack_public_path__ + "img/gzh.743b57ad.jpg";